import { Component, Input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { RouterLink, RouterLinkActive } from "@angular/router";

import { Bruger } from "../../bruger";
import { ForsyningIndstillinger } from "../../forsyning-indstillinger";
import { UmbracoIndstillinger } from "../../umbraco-indstillinger";
import { FeatureHighlightDirective } from "../feature-highlight/feature-highlight.directive";
import { FeatureHighlightKey } from "../feature-highlight/feature-highlight.model";
import { ServiceProUserMenu } from "../user-menu/service-pro-user-menu";

@Component({
  selector: "top-navigation",
  imports: [
    ServiceProUserMenu,
    MatIcon,
    RouterLink,
    RouterLinkActive,
    FeatureHighlightDirective,
  ],
  templateUrl: "./top-navigation.html",
  styleUrl: "./top-navigation.scss",
})
export class TopNavigation {
  @Input()
  public indstillinger: UmbracoIndstillinger;

  @Input()
  public aktuelBruger: Bruger | null = null;

  @Input()
  public aktuelForsyning: ForsyningIndstillinger | null = null;

  @Input()
  public menuItems: {
    label: string;
    icon: string;
    route: string;
    id?: string;
    featureHighlight?: FeatureHighlightKey;
  }[] = [];
}
